import styled from 'styled-components';
import React from 'react';
import ChevronRight from '@sls-react/static/svg/ChevronRight';
import useMobile from '@sls-react/hooks/useMobile';

export const CarouselButton = styled.button`
  position: absolute;
  top: calc(50% - 24px);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 17px 8px;
  outline: none;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
  }
`;

export const CarouselPreviousButton: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({ onClick }) => (
  <CarouselButton className="rounded-r" onClick={onClick}>
    <ChevronRight
      height={14}
      fill="#4a4a4a"
      css={`
        transform: rotate(180deg);
      `}
    />
  </CarouselButton>
);

export const CarouselNextButton: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({ onClick }) => (
  <CarouselButton className="right-0 rounded-l" onClick={onClick}>
    <ChevronRight height={14} fill="#4a4a4a" />
  </CarouselButton>
);

export const CarouselPortalContainer: React.FC<{ itemId: number }> = ({
  itemId,
}) => (
  <div
    css={`
      position: sticky;
      top: 120px;
      z-index: 1000;
    `}
  >
    <div
      css={`
        position: absolute;
        z-index: 120;
        top: 0;
        left: 0;

        img {
          max-width: none !important;
        }
      `}
      id={`desktop-carousel-portal-${itemId}`}
    />
  </div>
);

export const DetailsTable = styled.table`
  font-size: 14px;
  width: 100%;

  tr {
    &:last-child {
      td {
        padding-bottom: 0;
      }
    }

    td {
      padding-bottom: 8px;
      vertical-align: top;

      &:first-child {
        color: #9b9b9b;
      }

      &:last-child {
        font-weight: 600;
        text-align: right;
      }
    }
  }
`;

interface ItemDetailsSectionProps {
  header: string;
  linkElement?: any;
  linkProps?: any;
  showLink?: boolean;
}

export const ItemDetailsSection: React.FC<ItemDetailsSectionProps> = ({
  children,
  header,
  linkElement: Element,
  linkProps,
  showLink = true,
}) => {
  const mobile = useMobile();

  const link = showLink && (
    <Element
      {...linkProps}
      className="flex items-center justify-between py-2 md:inline-flex md:p-0"
    >
      <span className="text-sm font-normal text-primary-500 md:mr-1">
        See More
      </span>
      <ChevronRight height={12} />
    </Element>
  );

  return (
    <section className="mb-4">
      <div className="mb-2 md:flex md:justify-between">
        <h3 className="text-base">{header}</h3>
        {!mobile && showLink && link}
      </div>

      {children}

      {mobile && showLink && link}
    </section>
  );
};
